import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { ParcellaStragiudiziale } from '../../../models/parcella-stragiudiziale';
import { NumericOperationManager } from '../../../utils/numeric-operation-manager';

declare var removeEmptyObject: any;
@Component({
    selector: 'div [parcella-stragiudiziale-riepilogo-form]',
  templateUrl: 'parcella-stragiudiziale-riepilogo-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ParcellaStragiudizialeRiepilogoForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input() parcellaStragiudiziale: ParcellaStragiudiziale;

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }
}
